import { WarehouseLocationResource  } from "../api/barcodeSystem/warehouseLocations/get";
import { CreateWarehouseLocationRequest , UpdateWarehouseLocationRequest } from "../api/barcodeSystem/warehouseLocations/create";

export class EditWarehouseLocationModel {
    id: number | null;
    code: string| null;
    description: string| null;
    facilityCode: string| null;
    cycleCountClass: string| null;
    lastCycleCountDate: string| null;
    cycleCountedBy: string| null;
    isActive: boolean;
    isSystemLocation: boolean;
    locked: string | null;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    isNew(): boolean {
        return this.id == null;
    }

    showForNewWarehouseLocation(facilityCode: string) {
        this.loading = false;
        this.id = null;
        this.code = null;
        this.description = null;
        this.facilityCode = facilityCode;
        this.cycleCountClass = null;
        this.isActive = true;
        this.isSystemLocation = false;
        this.lastCycleCountDate  = null;
        this.cycleCountedBy  = null;     
        this.locked = null;
    }

    showForExistingWarehouseLocation(warehouseLocation: WarehouseLocationResource) {
        this.loading = false;
        this.id = warehouseLocation.id;
        this.code = warehouseLocation.code;
        this.description = warehouseLocation.description;
        this.facilityCode = warehouseLocation.facilityCode;
        this.cycleCountClass = warehouseLocation.cycleCountClass;
        this.isActive = warehouseLocation.isActive;
        this.lastCycleCountDate = warehouseLocation.lastCycleCountDate;
        this.cycleCountedBy = warehouseLocation.cycleCountedBy;
        this.isSystemLocation = warehouseLocation.isSystemLocation;
        this.locked = warehouseLocation.locked;
    }

    toCreateWarehouseLocationRequest(): CreateWarehouseLocationRequest {
        return { 
          code: this.code, 
          description: this.description,
          facilityCode: this.facilityCode,
          cycleCountClass: this.cycleCountClass
        };
    }

    toUpdateWarehouseLocationRequest(): UpdateWarehouseLocationRequest {
        return {
            id: this.id,
            code: this.code, 
            description: this.description,
            facilityCode: this.facilityCode,
            cycleCountClass: this.cycleCountClass,
            isActive: this.isActive
        };
    }
}
